module.exports = __webpack_public_path__ + "static/cruisin-0fdc6ec7bda4fc7582b4df931979478c.jpg";